export default "__VITE_PUBLIC_ASSET__c617a2b2__"